
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type alphabeticalContainerRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function alphabeticalContainerRT(): TemplateResult<alphabeticalContainerRTRootProps> {
    function repeatAlphabeticalLetters1(alphabeticalLetters, alphabeticalLettersIndex) {
        return [alphabeticalLetters(function () {
                return _createElement('div', {
                    'className': 'cm_vehicle-categories__letters-letter' + (this.currentLetter === this.letter ? ' active' : '') + (this.isDisabled ? ' disabled' : ''),
                    'title': this.letter,
                    'onClick': () => this.setCurrentLetter(this.letter)
                }, '\n  ', this.letter, '\n');
            }, { count: undefined })];
    }
    function repeatAlphabeticalGroups2(view, alphabeticalGroups, alphabeticalGroupsIndex) {
        return [alphabeticalGroups(function () {
                function repeatTiles1(tiles, tilesIndex) {
                    return [tiles(function () {
                            return _createElement('a', {
                                'className': 'cm_vehicle-categories_category-container cm_vehicle-categories_link',
                                'href': this.href
                            }, _createElement('div', { 'className': 'cm_vehicle-categories_category-image-container cm_vehicle-categories_link' }, this.imageUrl ? _createElement('img', {
                                'className': 'cm_vehicle-categories_category-image',
                                'src': this.imageUrl,
                                'alt': this.value,
                                'key': '214'
                            }) : null, !this.imageUrl ? _createElement('span', {
                                'className': 'cm_vehicle-categories_category-image-text',
                                'key': '340'
                            }, this.value) : null), _createElement('h3', { 'className': 'cm_vehicle-categories_category-title' }, this.value));
                        }, { count: undefined })];
                }
                function repeatTiles2(tiles, tilesIndex) {
                    return [tiles(function () {
                            return _createElement('a', {
                                'className': 'cm_vehicle-categories_category-wrapper-title-link',
                                'href': this.href,
                                'title': this.value
                            }, _createElement('h3', { 'className': 'cm_vehicle-categories_category-wrapper-title-link-text' }, this.value));
                        }, { count: undefined })];
                }
                return this.tiles.length ? _createElement('div', {
                    'className': 'cm_vehicle-categories_category-wrapper',
                    'key': '0'
                }, view === 'grid' ? [
                    _createElement('h2', {
                        'className': 'cm_vehicle-categories_category-repeater-letter',
                        'key': '821'
                    }, this.letter),
                    _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_vehicle-categories_category-repeater  cmRepeater_tiles',
                            'key': '823'
                        },
                        _map(this.tiles, repeatTiles1.bind(this))
                    ])
                ] : null, view === 'columns' ? [
                    _createElement('h2', {
                        'className': 'cm_vehicle-categories_category-repeater-letter',
                        'key': '12641'
                    }, this.letter),
                    _createElement('div', {
                        'className': 'cm_vehicle-categories_category-repeater-container',
                        'key': '12643'
                    }, _createElement.apply(this, [
                        'div',
                        { 'className': 'cm_vehicle-categories_category-repeater  cmRepeater_tiles' },
                        _map(this.tiles, repeatTiles2.bind(this))
                    ]))
                ] : null) : null;
            }, { count: undefined })];
    }
    function scopeView3() {
        var view = this.view;
        return _createElement.apply(this, [
            'div',
            { 'className': 'cm_vehicle-categories_category-wrapper-repeater' + (this.currentLetter !== 'All' ? ' filtered' : '') + '  cmRepeater_alphabeticalGroups' },
            _map(this.alphabeticalGroups, repeatAlphabeticalGroups2.bind(this, view))
        ]);
    }
    return _createElement('div', { 'className': 'cm_vehicle-categories cm_vehicle-categories__alphabetical cm_vehicle-categories__alphabetical-' + this.view }, [this.vehicleWidget(function () {
            function repeatSelects1(selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(isQualifierField, popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n              ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n            ');
                        }
                        function repeatEntry2(isQualifierField, popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField3(isQualifierField) {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n            ', _translate(`select_title`), ' ', this.title, '\n          ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                isPopularField ? [
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-popular',
                                        'disabled': true,
                                        'key': '13431'
                                    }, _translate(`ymm_bar_popular`)),
                                    _map(popularEntries, repeatEntry1.bind(this, isQualifierField, popularEntries, unpopularEntries, isPopularField)),
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-unpopular',
                                        'disabled': true,
                                        'key': '13434'
                                    }, _translate(`ymm_bar_unpopular`))
                                ] : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, isQualifierField, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        function scopeShowSelectedValues4(isQualifierField) {
                            var showSelectedValues = this.selectedEntries.length;
                            return _createElement('option', {
                                'key': '_current',
                                'value': '_current'
                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                _translate(`select_title`),
                                ' ',
                                this.title
                            ] : null);
                        }
                        function repeatEntry5(isQualifierField, entry, index) {
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value,
                                'onClick': () => this.onChange(entry.term)
                            }, this.showCheckboxes ? _createElement('input', {
                                'type': 'checkbox',
                                'readOnly': true,
                                'checked': entry.selected,
                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                'key': '3617'
                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                'className': 'cm_dropdown_hitCount',
                                'key': '3823'
                            }, entry.hitCount) : null);
                        }
                        function mergeProps(inline, external) {
                            var res = Object.assign({}, inline, external);
                            if (inline.hasOwnProperty('style')) {
                                res.style = _.defaults(res.style, inline.style);
                            }
                            if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                res.className = external.className + ' ' + inline.className;
                            }
                            return res;
                        }
                        function scopeDescription7(isQualifierField) {
                            var description = _translate(`facet_details_${ this.field }`);
                            return [description ? _createElement('div', {
                                    'className': 'cm_select-qualifier-details',
                                    'key': '43591'
                                }, _createElement('button', { 'className': 'cm_select-qualifier-details_button' }, [_createElement('svg', {
                                        'width': '24',
                                        'height': '24',
                                        'viewBox': '0 0 24 24',
                                        'fill': 'none',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'key': '45860'
                                    }, _createElement('g', { 'opacity': '0.6' }, _createElement('circle', {
                                        'cx': '12',
                                        'cy': '12',
                                        'r': '11.5',
                                        'stroke': 'black'
                                    }), _createElement('path', {
                                        'd': 'M12.768 14.72H11.28C11.28 13.8453 11.6267 13.0613 12.32 12.368C12.384 12.304 12.5867 12.112 12.928 11.792C13.28 11.4613 13.5093 11.232 13.616 11.104C13.7333 10.9653 13.8613 10.7573 14 10.48C14.1493 10.2027 14.224 9.936 14.224 9.68C14.224 9.15733 14.0427 8.752 13.68 8.464C13.3173 8.176 12.8373 8.032 12.24 8.032C11.0667 8.032 10.3147 8.54933 9.984 9.584L8.72 8.88C8.976 8.15467 9.41867 7.59467 10.048 7.2C10.688 6.79467 11.424 6.592 12.256 6.592C13.1947 6.592 14.0053 6.85867 14.688 7.392C15.3707 7.91467 15.712 8.656 15.712 9.616C15.712 10.448 15.3653 11.2107 14.672 11.904C14.6187 11.9573 14.4533 12.1173 14.176 12.384C13.8987 12.64 13.712 12.8267 13.616 12.944C13.52 13.0507 13.3867 13.216 13.216 13.44C13.0453 13.664 12.928 13.8773 12.864 14.08C12.8 14.2827 12.768 14.496 12.768 14.72ZM12.016 18.176C11.728 18.176 11.4827 18.0747 11.28 17.872C11.0773 17.6693 10.976 17.424 10.976 17.136C10.976 16.848 11.0773 16.6027 11.28 16.4C11.4827 16.1973 11.728 16.096 12.016 16.096C12.3147 16.096 12.56 16.1973 12.752 16.4C12.9547 16.6027 13.056 16.848 13.056 17.136C13.056 17.424 12.9547 17.6693 12.752 17.872C12.56 18.0747 12.3147 18.176 12.016 18.176Z',
                                        'fill': 'black'
                                    })))]), _createElement('div', { 'className': 'cm_select-qualifier-details_content' }, _createElement('div', mergeProps({ 'className': 'cm_select-qualifier-details_content-title' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'cm_select-qualifier-details_content-text' }, description))) : null];
                        }
                        function repeatEntry8(isQualifierField, entry, entryIndex) {
                            return _createElement('div', {
                                'key': entry.value,
                                'className': 'cm_select-qualifier-value' + (entry.selected ? ' cm_select-qualifier-value_selected' : ''),
                                'onClick': () => this.onChange(entry.term)
                            }, '\n          ', entry.value, '\n        ');
                        }
                        function scopeIsQualifierField9() {
                            var isQualifierField = this.field?.startsWith('Qualifier_');
                            return _createElement('div', { 'className': this.extraClassName + (isQualifierField ? ' cm_select-qualifier-container' : '') }, !isQualifierField ? [
                                !this.isSearchable ? _createElement('div', {
                                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                    'key': '1951'
                                }, _createElement('select', {
                                    'className': 'cm_select_inner-select cm_form-select form-select form-select--small',
                                    'onChange': this.onChange,
                                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                    'disabled': this.disabled,
                                    'aria-label': this.title
                                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, [isQualifierField]) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, [isQualifierField]) : null)) : null,
                                this.isSearchable ? [[this.filterInput(function () {
                                            return _createElement('div', { 'className': 'cm_filterInput' });
                                        }, {
                                            widgetName: 'undefined',
                                            items: undefined
                                        })]] : null,
                                !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                    'div',
                                    {
                                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                        'aria-label': this.title,
                                        'key': '1955'
                                    },
                                    !this.hideNullOption ? _createElement('div', {
                                        'className': 'option',
                                        'key': 'null-option',
                                        'onClick': () => this.onChange('')
                                    }, '\n        ', _translate(`select_title`), ' ', this.title, '\n      ') : null,
                                    this.loading ? _createElement('div', {
                                        'className': 'option',
                                        'key': 'null-option',
                                        'disabled': true
                                    }, _translate(`select_loading`)) : null,
                                    !this.loading ? _map(this.entries, repeatEntry5.bind(this, isQualifierField)) : null
                                ]) : null
                            ] : null, isQualifierField ? [
                                _createElement('div', {
                                    'className': 'cm_select-qualifier-additional_details',
                                    'key': '39481'
                                }, _translate(`ymm_bar_additional_details`)),
                                _createElement('div', {
                                    'className': 'cm_select-qualifier',
                                    'key': '39483'
                                }, _createElement('div', { 'className': 'cm_select-qualifier-header' }, _createElement('div', mergeProps({ 'className': 'cm_select-qualifier-title' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), scopeDescription7.apply(this, [isQualifierField])), _createElement.apply(this, [
                                    'div',
                                    { 'className': 'cm_select-qualifier-value_repeater' },
                                    _map(this.entries, repeatEntry8.bind(this, isQualifierField))
                                ]))
                            ] : null);
                        }
                        return scopeIsQualifierField9.apply(this, []);
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__vehicle-categories cm_vehicleWidget' }, this.template === 'active' ? _createElement('div', {
                'className': 'cm_vehicle-widget_dropdowns cmTemplate_active',
                'key': '86'
            }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, window.Convermax.config?.selectYourVehicleTitle || _translate(`ymm_bar_title`)), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                _map(this.selects, repeatSelects1.bind(this))
            ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go button',
                'onClick': this.selectVehicle,
                'disabled': !this.allowToSetVehicle,
                'role': 'button',
                'tabIndex': this.allowToSetVehicle ? '0' : '-1'
            }, '\n    ', _translate(`ymm_bar_submit`), '\n  '), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear button button--secondary',
                'onClick': this.discardVehicle,
                'disabled': !this.allowToDiscardVehicle,
                'role': 'button',
                'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
            }, [_createElement('svg', {
                    'className': 'cm_icon',
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'width': '16',
                    'height': '16',
                    'viewBox': '0 0 16 16',
                    'fill': 'none',
                    'key': '115740'
                }, _createElement('g', { 'clipPath': 'url(#clip0_2479_277)' }, _createElement('path', {
                    'd': 'M0.666748 2.66675V6.66675H4.66675',
                    'stroke': '#646B77',
                    'strokeWidth': '2',
                    'strokeLinecap': 'round',
                    'strokeLinejoin': 'round'
                }), _createElement('path', {
                    'd': 'M15.3333 13.3333V9.33325H11.3333',
                    'stroke': '#646B77',
                    'strokeWidth': '2',
                    'strokeLinecap': 'round',
                    'strokeLinejoin': 'round'
                }), _createElement('path', {
                    'd': 'M13.6601 5.99989C13.322 5.04441 12.7473 4.19016 11.9898 3.51683C11.2322 2.84351 10.3164 2.37306 9.32789 2.14939C8.33934 1.92572 7.31025 1.95612 6.33662 2.23774C5.363 2.51936 4.47658 3.04303 3.76008 3.75989L0.666748 6.66655M15.3334 9.33322L12.2401 12.2399C11.5236 12.9567 10.6372 13.4804 9.66354 13.762C8.68992 14.0437 7.66082 14.0741 6.67227 13.8504C5.68373 13.6267 4.76795 13.1563 4.01039 12.4829C3.25284 11.8096 2.67819 10.9554 2.34008 9.99989',
                    'stroke': '#646B77',
                    'strokeWidth': '2',
                    'strokeLinecap': 'round',
                    'strokeLinejoin': 'round'
                })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_2479_277' }, _createElement('rect', {
                    'width': '16',
                    'height': '16',
                    'fill': 'white'
                }))))], ' ', _translate(`ymm_bar_clear`), '\n  ')))) : null, this.template === 'locked' ? _createElement('div', {
                'className': 'cm_vehicle-widget_label cmTemplate_locked',
                'key': '12740'
            }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, '\n  ', this.vehicleString, '\n  ', _createElement('span', { 'className': 'cm_vehicle-widget_subtitle' }, this.fitmentSearchTitle), [this.facetToggle(function () {
                    return _createElement('div', { 'className': 'cm_facetToggle' }, _createElement('span', {
                        'className': 'cm_facet-toggle_label',
                        'onClick': this.toggleFacet
                    }, '\n  ', _translate(`facet_toggle_label`), '\n'), _createElement('label', { 'className': 'cm_facet-toggle_switch' }, _createElement('input', {
                        'className': 'cm_facet-toggle_input',
                        'type': 'checkbox',
                        'checked': this.isToggled,
                        'onChange': this.toggleFacet
                    }), _createElement('span', { 'className': 'cm_facet-toggle_slider' })));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget__change button',
                'onClick': this.changeVehicle,
                'role': 'button',
                'tabIndex': '0'
            }, '\n      ', _translate(`ymm_bar_change`), '\n    '), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget__discard button button--secondary',
                'onClick': this.discardVehicle,
                'role': 'button',
                'tabIndex': '0'
            }, [_createElement('svg', {
                    'className': 'cm_icon cm_icon-times',
                    'height': '20px',
                    'role': 'img',
                    'viewBox': '0 0 22 22',
                    'key': '142270'
                }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))], ' ', _translate(`ymm_bar_discard`), '\n    ')))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-categories__letters cmRepeater_alphabeticalLetters' },
        _map(this.alphabeticalLetters, repeatAlphabeticalLetters1.bind(this))
    ]), scopeView3.apply(this, []));
}
        export const componentNames = ["cm:filterInput","cm:facetToggle","cm:vehicleWidget"]